<template>
  <div class="custom-checkbox">
        <div class="detail">
          <div v-if="!detailArr.length" class="no-data">没有数据</div>
          <div class="content" v-else>
            <div
              v-for="item in detailArr"
              :key="item.id"
              class="item"
              @click.stop="handleChange(item.name)"
            >
              <input
                type="checkbox"
                :key="item.id"
                :checked="modelValue.includes(item.name)"
              />
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    // 源数据
    data: {
      type: Array,
      default () {
        return []
      }
    },
    modelValue: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selectedIndex: null,
      detailArr: [{
        id: '3d',
        name: '3D模型'
      }],
      height: 0,
      timer: null,
      id: null,
      detailTop: '',
      triangleLeft: ''
    }
  },
  methods: {
    // 属性值选择改变
    handleChange (id) {
      const selectedIds = [...this.modelValue]
      const index = selectedIds.indexOf(id)
      if (index >= 0) {
        selectedIds.splice(index, 1)
      } else {
        selectedIds.push(id)
      }
      this.$emit('update:modelValue', selectedIds)
    },
    // 点击属性
    handleClick (index, id, e) {
      this.id = id

      const offsetTop = e.currentTarget.offsetTop
      // console.log('offsetTop', e.currentTarget, offsetTop, offsetTop + 37)
      const offsetLeft = e.currentTarget.offsetLeft
      this.detailTop = `calc(${this.pxToRem(offsetTop + 37)})`
      this.triangleLeft = `calc(${this.pxToRem(offsetLeft + 173)})`

      // 所有的都没有点开
      if (this.selectedIndex === null) {
        this.display(index)
        // this.$emit('clickAttribute', id)
        return
      }
      // 点击相同的按钮
      if (this.selectedIndex === index) {
        this.hide()
        return
      }
      // 点击不同按钮
      if (this.selectedIndex !== index) {
        // this.selectedArr = []
        this.hide()
        setTimeout(() => {
          // this.$emit('clickAttribute', id)
          this.display(index)
        }, 0)
      }
    },
    // 展示该属性下的所有属性值
    display (index) {
      if (this.timer) {
        clearTimeout(this.timer)
      }

      setTimeout(() => {
        this.detailArr = [...this.data[index].detailArr]
        // this.height = parseFloat((82 + 38 * Math.ceil(this.detailArr.length/4))/16).toFixed(4)
        this.height = this.pxToRem(286)
        this.selectedIndex = index
      }, 10)
    },
    // 隐藏该属性下的所有属性值
    hide () {
      this.height = 0
      this.selectedIndex = null
    },
    // 1920分辨率的情况下
    pxToRem (px) {
      return parseFloat(px / 192).toFixed(4) + 'rem'
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-checkbox {
  /*font-family: 'NotoSerifSC';*/
  position: relative;
  display: flex;
}

.btn-container {
  margin-right: 34px;
  margin-bottom: 25px;
}

.btn {
  display: flex;
  align-items: center;
  min-width: 103px;
  height: 37px;
  line-height: 35px;
  border-radius: 5px;
  padding: 0 25px;
  background: white;
  border: 1px solid #C4C4C4;
  font-size: 21px;
  font-weight: 600;
  color: black;
  img {
    width: 8px;
    height: 8px;
    right: 15px;
    margin-left: 21px;
  }
  span {
    font-family: 'NotoSerifSC', system-ui;
  }
}

.pillar {
  width: 100%;
}

.all-select {
  position: absolute;
  left: -123px;
  right: -123px;
  transition: all 0.5s;
  overflow: hidden;
  z-index: 99;
}

.detail {
  width: 1920px;
  height: 254px;
  background: white;
  overflow: hidden;
  position: relative;
  top: 18px;
  border-top: 1px solid #C4C4C4;
  border-bottom: 1px solid #C4C4C4;
  overflow-y: auto;
}

.detail::-webkit-scrollbar {
  display: none;
}

.triangle {
  width: 21px;
  height: 21px;
  position: absolute;
  top: 0;
  z-index: 99;
}

.content {
  display: flex;
  width: 1920px;
  padding: 41px 246px;
  background: white;
  position: relative;
  top: -7px;
}

.no-data {
  font-size: 12px;
  text-align: center;
  padding: 41px 0;
  color: #969799;
}

.item {
  display: flex;
  align-items: center;
  width: 25%;
  margin-bottom: 21px;
}

.item input {
  width: 20px;
  position: relative;
}

.item div {
  width: calc(100% - 20px);
  font-size: 21px;
  font-weight: 400;
  line-height: 27px;
  padding-left: 13px;
}
</style>
